import React from 'react';

import FieldIcon from '@atlaskit/icon/core/field';
import type { JiraAdminAgentFieldStepPayload } from '@atlassian/ai-mate-jira-admin-agent-api/jira-admin-agent';

import { FieldCard } from './FieldCard';

export const FieldBody = ({
	payload,
}: {
	payload: JiraAdminAgentFieldStepPayload['payload'];
}): React.JSX.Element => {
	const { fieldName, fieldOptions, fieldType } = payload;
	return (
		<FieldCard
			fieldIcon={<FieldIcon label="" />}
			fieldName={fieldName}
			fieldOptions={fieldOptions}
			fieldType={fieldType}
		/>
	);
};
